import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class LogicInverter extends ASTBlock {
    constructor(color) {
        super(color, "logic_inverter")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "nicht %1",
            "args0": [{
                "type": "input_value",
                "name": "arg0",
                "check": "Boolean"
            }],
            "output": "Boolean",
            "inputsInline": false
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}